import "./App.css";
import Router from "./RouterPage/Router";

function App() {
  return (
    <div className="font-sans">
      <Router />
    </div>
  );
}

export default App;
